import React from "react";
import html2canvas from "html2canvas";
import * as jsPDF from "jspdf";
window.html2canvas = html2canvas;

const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
  const downloadPdfDocument = () => {
    const input = document.getElementById(rootElementId);
    html2canvas(input, { useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      canvas.width = document.body.clientWidth;
      const pdf = new jsPDF("l", "mm", "a4");
      pdf.addImage(imgData, "JPEG", 10, 10, 268, 200);
      pdf.save(`${downloadFileName}.pdf`);
    });
  };

  return (
    <button
      className="btn btn-default align-self-center d-none d-md-flex"
      style={{
        color: "#1782F4",
        //   border: '3px solid #00f',
        borderRadius: "5px !important",
        background: "#fff",
      }}
      onClick={downloadPdfDocument}
    >
      <strong>Download PDF</strong>
    </button>
  );
};

export default GenericPdfDownloader;
